import { ca } from '@cian/analytics';

import { TGallerySiteType } from '../../types/analytics';

export type TSellerType = 'builders' | 'agents';

interface ITrackShowPhone {
  newbuildingId: number;
  url: string;
  sellerType?: TSellerType;
  siteType?: TGallerySiteType;
}

export function trackShowPhone({ newbuildingId, url, sellerType }: ITrackShowPhone) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_compare_jk_listing',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        compare_type: 'newbuildings',
        ...(sellerType ? { seller_type: sellerType } : {}),
      },
    },
  });
}

interface ITrackOpenContacts {
  newbuildingId: number;
  url: string;
}

export function trackOpenContacts({ newbuildingId, url }: ITrackOpenContacts) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'open_contacts',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
  });
}

export function trackShowPhoneGallery({ newbuildingId, url, siteType }: ITrackShowPhone) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_compare_jk_fullscreen_gallery',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: 'builders',
      },
      siteType: siteType,
      pageType: 'ListingCompareJK',
    },
  });
}
